<!--
 * @Author: pyx 3245266940@qq.com
 * @Date: 2023-04-10 17:01:00
 * @LastEditors: pyx 3245266940@qq.com
 * @LastEditTime: 2023-04-19 18:40:21
 * @FilePath: \org-wx-front\src\views\Mine\mine.vue
 * @Description: 这是默认设置,请设置`customMade`, 打开koroFileHeader查看配置 进行设置: https://github.com/OBKoro1/koro1FileHeader/wiki/%E9%85%8D%E7%BD%AE
-->
<template>
    <div class="wrapBox">
        <!-- 联系旭课的提示 -->
        <popup title="联系旭课" tips="旭课运营人员稍后会联系您" v-if="popupShow" @event="popupEvent"></popup>
        <div class="infoWrap">
            <div class="rowAc infoBox">
                <div class="rowJcAc avatarUrl">
                    <img :src="customerInfo.avatarUrl" alt="" class="avatarUrlImg">
                </div>
                
                <div class="infoNameBox">
                    <div class="customerName">{{ customerInfo.username}}</div>
                    <div class="customerPhone rowAc">
                        <img src="../../assets/static/mine/phone.svg" class="phoneImg" alt="">
                        <div>{{ customerInfo.phone }}</div>
                    </div>
                </div>
            </div>
            
        </div>
        <div class="sectionWrap">
            <div class="institutionWrap">
                <div class="rowAc">
                    <img src="../../assets/static/mine/institutionIcon.svg" alt="" class="institutionIcon">
                    <div>机构列表</div>
                </div>
                <div class="line"></div>
                <div class="institutionList">
                    <div 
                        v-for="(item,index) in institutionList" 
                        :key="index"
                        class="institutionItem textOver"
                    >{{ item.institutionName }}</div>
                </div>
                <div class="emptyText" v-if="!institutionList || institutionList.length == 0">暂无</div>
            </div>
            <div class="list">
                <div class="cardItem rowJbAc" @click="clickMyDiscount">
                    <div class="rowAc">
                        <img src="../../assets/static/mine/discountCouponIcon.svg" alt="" class="itemIcon">
                        <div>我的优惠券</div>
                    </div>
                    <div class="icon-arrow-left"></div>
                </div>
                <div class="cardItem rowJbAc" @click="linkXk">
                    <div class="rowAc">
                        <img src="../../assets/static/mine/messageIcon.svg" alt="" class="itemIcon">
                        <div>联系旭课</div>
                    </div>
                    <div class="icon-arrow-left"></div>
                </div>
            </div>
        </div>
        <div class="bottomBox colAc">
            <div class="btn" @click="deleteAccountCancel">切换账号</div>
            <div class="tips">深圳转角马科技有限公司提供技术支持</div>
        </div>
    </div>
</template>
<script>
import {getAuthorizeListAPI,deleteAccountCancelAPI} from '../../utils/api/api'
import popup from '../../components/Mine/popup.vue'
export default {
    components: {popup},
    data() {
        return {
            institutionList: [], // 机构列表
            customerInfo: null, // 客户信息
            popupShow: false, // 弹框是否展示
        }
    },
    created() {
        this.getAuthorizeList()
        this.customerInfo = JSON.parse(this.$common.getCache('customerInfo'))
        if(!this.customerInfo.avatarUrl || this.customerInfo.avatarUrl.indexOf('../') == 0) {
            if(this.customerInfo.sex == 0) {
                this.customerInfo['avatarUrl'] = require('../../assets/static/mine/woman.png')
            }else {
                this.customerInfo['avatarUrl'] = require('../../assets/static/mine/man.png')
            }
        }
    },
    methods: {
        clickMyDiscount() {
            console.log('点击我的优惠券')
            this.$router.push('/mineDiscount')
        },
        getAuthorizeList() {
            getAuthorizeListAPI({
                productId: 1,
                clientId: '1004',
                thirdUniqueId: this.$common.getCache('openid')
            }).then(res => {
                if(res.resultCode == 200) {
                    this.institutionList = res.data
                }
            })
        },
        // 注销授权信息
        deleteAccountCancel() {
            deleteAccountCancelAPI().then(res => {
                console.log('注销账号：', res)
                if(res.resultCode == 200) {
                    this.$common.removeCache('token')
                    this.$common.removeCache('customerInfo')
                    this.$common.removeCache('tokenCreateTime')
                    this.$router.replace('/login')
                    
                }
            })
        },
        // 点击联系旭课
        linkXk() {
            this.popupShow = true
        },
        // 弹框触发的事件
        popupEvent() {
            this.popupShow = false
        }
    }
}
</script>
<style lange="scss" scoped>
.infoWrap {
    overflow: hidden;
    width: 100%;
    height: 1.74rem;
    background: linear-gradient(90deg, #5685F2 0%, #A8C2FF 100%);
}
.sectionWrap {
    padding: 0 0.16rem;
    min-height: 3.36rem;
}
.institutionWrap {
    background: #ffffff;
    border-radius: .12rem;
    margin-top: -0.38rem;
    padding: 0.16rem;
    /* max-height: 2.44rem; */
    font-size: .16rem;
    line-height: .22rem;
    box-shadow: 0px 6px 30px 5px rgba(132, 134, 138, 0.04),0px 9px 24px 2px rgba(132, 134, 138, 0.04),0px 8px 10px -5px rgba(132, 134, 138, 0.04);
    
}
.line {
    height: 1px;
    background-color: #E8EBF3;
    margin-top: .16rem;
    margin-bottom: .04rem;
}
.infoNameBox {
    flex: 1;
    padding-right: .24rem;
}
.institutionItem {
    margin-top: .12rem;
    padding-left: .3rem;
    line-height: .22rem;
    font-size: .15rem;
}
.institutionList {
    overflow: auto;
    max-height: 1.36rem;
}
.institutionIcon {
    width: .2rem;
    height: .2rem;
    margin-right: .08rem;
}
.list {
    margin-top: .16rem;
}
.cardItem {
    height: .54rem;
    padding: 0 .16rem;
    font-size: .16rem;
    color: #191C27;
    line-height: .22rem;
}
.itemIcon {
    width: .2rem;
    height: .2rem;
    margin-right: .1rem;
}
.icon-arrow-left {
    font-size: .16rem;
    color: #9EA5BB;
}
.bottomBox {
    margin-top: .8rem;
    /* position: fixed; */
    width: 100%;
    /* bottom: 1.12rem; */
}
.btn {
    width: 1.12rem;
    height: .42rem;
    line-height: .42rem;
    text-align: center;
    font-size: .16rem;
    color: #9EA5BB;
    background-color: #EEF2F6;
    border-radius: .21rem;
}
.tips {
    font-size: .13rem;
    color: #9EA8BA;
    line-height: .18rem;
    margin-top: .16rem;
}
.avatarUrl {
    min-width: .6rem;
    min-height: .6rem;
    width: .6rem;
    height: .6rem;
    border-radius: 50%;
    margin-right: .14rem;
    margin-left: .24rem;
    border: 1px solid #ffffff;
    overflow: hidden;
    box-sizing: border-box;
    box-shadow: 0px 6px 30px 5px rgba(0, 0, 0, 0.05),0px 16px 24px 2px rgba(0, 0, 0, 0.04),0px 8px 10px -5px rgba(0, 0, 0, 0.08);
}
.avatarUrlImg {
    width: 100%;
    height: 100%;
}
.customerName {
    font-size: .18rem;
    font-weight: 500;
    line-height: .26rem;
    margin-bottom: .04rem;
    color: #ffffff;
    width: 100%;
    word-break: break-all;
}
.customerPhone {
    color: #ffffff;
    font-size: .14rem;
    line-height: .2rem;
}
.phoneImg {
    width: .16rem;
    height: .16rem;
    margin-right: .06rem;
}
.infoBox {
    margin-top: .46rem;
    width: 100%;
}
.emptyText {
    text-align: center;
    line-height: .22rem;
    font-size: .15rem;
    color: #C8C9CC;
    padding-top: .16rem;
}
</style>